<template>
  <div>
    <v-checkbox
      v-for="option in options"
      :key="option.id"
      :label="option.title"
      :value="option.title"
      color="blue darken-4"
      hide-details
      :data-question="question.id"
      v-model="answers"
      @change="push(option.title)"
    ></v-checkbox>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      answers: []
    };
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  computed: {
    
  },
  methods: {
    push(option){
      this.$emit('get_answer', { option: option, question: this.question})
    },
  },
  validations: {
    answers: {
      required
    }
  }
};
</script>

<style>
</style>